import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { LockClosedIcon } from '@heroicons/react/24/outline';
import { getSupabaseClient } from '../../lib/supabase';

export function AccountBlockedPage() {
  const navigate = useNavigate();

  const handleReturnHome = useCallback(async () => {
    const supabase = getSupabaseClient();
    await supabase.auth.signOut();
    navigate('/', { replace: true });
  }, [navigate]);

  return (
    <div className="flex min-h-screen flex-col bg-[#2C2731] text-[#FEF6D6]">
      <header className="border-b border-[#FEF6D6]/10 px-6 py-4 flex justify-center">
        <img src="/gclogo.webp" alt="Guides Collective" className="h-8 w-auto" />
      </header>

      <main className="flex flex-1 items-center justify-center px-4">
        <div className="w-full max-w-lg rounded-3xl border border-[#FEF6D6]/20 bg-[#2C2731] p-10 text-center shadow-[0_20px_40px_rgba(0,0,0,0.35)]">
          <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full border border-[#FEF6D6]/30 bg-[#FEF6D6]/5">
            <LockClosedIcon className="h-8 w-8 text-[#FEF6D6]" />
          </div>
          <h2 className="mb-3 text-3xl font-semibold">Your account has been blocked //</h2>
          <p className="text-sm text-[#FEF6D6]/80">
            For your safety and ours, access to this account has been temporarily disabled. Please reach out to our
            support team if you believe this is a mistake or need additional help.
          </p>
          <button
            type="button"
            onClick={handleReturnHome}
            className="mt-8 inline-flex items-center justify-center rounded-full border border-[#FEF6D6]/40 px-6 py-2 text-sm font-medium text-[#FEF6D6] transition hover:bg-[#FEF6D6]/10"
          >
            Return to homepage
          </button>
        </div>
      </main>
    </div>
  );
}
